import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useTeam, { useTeamForm } from '@hooks/useTeam'

import TeamDetails from '../TeamDetails'
import TeamMembers from '../TeamMembers'
import TeamTools from '../../../../components/TeamTools'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  teamId: number,
}

const PageContent = (props: PageContentProps) => {
  const { teamId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateTeam,
    },
  } = pageContext

  const teamPayload = useTeam({ id: teamId })
  const {
    callbacks: {
      updateTeam: updateFn,
    },
    loading,
    team,
    updating,
  } = teamPayload

  const teamFormPayload = useTeamForm(team)
  const { entityState, saveEnabled } = teamFormPayload

  const updateTeamPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Team Updated',
  }

  return (
    <PageLayout teamPayload={teamPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <TeamDetails teamFormPayload={teamFormPayload} />

            <TeamMembers teamId={teamId} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                //@ts-expect-error
                marginLeft="auto"
                onClick={() => updateTeam(updateTeamPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <TeamTools teamPayload={teamPayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
